/** @format */

import React from 'react'
import styled from 'styled-components'
import MonitorCrumb from 'src/components/MonitorCrumb'
import { useParams, useLocation, useHistory } from 'react-router'
import { Message, Card } from '@king-design/react'
import { useAsync, useAsyncFn } from 'react-use'
import { get } from 'lodash'
import { getScene, launchScene } from 'src/api/ApiEventOpsScene'
import LaunchForm from '../components/LaunchForm'

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const TriggerPage: React.FC<{ className?: string }> = ({ className }) => {
  const params = useParams()
  const sign = get(params, 'sign')
  const query = useQuery()
  const history = useHistory()
  const defaultValues = query.get('default') || '{}'

  const { value: sceneInfo } = useAsync(async () => {
    const result = await getScene(sign)
    return result
  }, [sign])

  const [, fetchLaunchScene] = useAsyncFn(
    async formValues => {
      const result = await launchScene({
        Inputs: formValues,
        Sign: sceneInfo?.Sign
      })
      if (result?.SceneRecordID) {
        Message.success('执行成功')
        history.push(`/monitor/eventops/record/detail/${result?.SceneRecordID}`)
      }
    },
    [sceneInfo?.Sign]
  )

  return (
    <div id="launch_scene" className={className}>
      <MonitorCrumb
        breadArr={[
          { title: '自动化运维' },
          { title: '自动化场景', route: '/monitor/eventops/scene' },
          { title: '执行场景' }
        ]}
      />
      <Card title={sceneInfo?.Name} type="border">
        <LaunchForm
          defaultValue={JSON.parse(defaultValues)}
          submitText="执行"
          hasPreview
          formSchema={sceneInfo?.FormSchema}
          onCallback={values => {
            fetchLaunchScene(values)
          }}
        />
      </Card>
    </div>
  )
}

export default styled(TriggerPage)`
  .bottom_action {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
`
